export const gToastSentiment = 'light';
export const gToastPosition = 'top-end';
